import { render, staticRenderFns } from "./DisplayAmount.vue?vue&type=template&id=65fa124a&scoped=true&"
import script from "./DisplayAmount.vue?vue&type=script&lang=js&"
export * from "./DisplayAmount.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAmount.vue?vue&type=style&index=0&id=65fa124a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa124a",
  null
  
)

export default component.exports